export const getSettings = (state) => state.settings.get('settings').toJS();
